import React, { useState } from 'react';
import { Mail, Phone, Send } from 'lucide-react';
export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitMessage('Thank you! Your message has been sent successfully.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      // Clear success message after 5 seconds
      setTimeout(() => {
        setSubmitMessage('');
      }, 5000);
    }, 1500);
  };
  return <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-28">
      <h3 className="text-2xl font-bold text-primary mb-6" data-id="element-29">Get in Touch</h3>
      <div className="mb-8 space-y-4" data-id="element-30">
        <div className="flex items-center" data-id="element-31">
          <Phone className="text-secondary mr-3" size={20} data-id="element-32" />
          <a href="tel:08000554969" className="text-dark hover:text-secondary" data-id="element-33">
            0800 055 4969
          </a>
        </div>
        <div className="flex items-center" data-id="element-34">
          <Mail className="text-secondary mr-3" size={20} data-id="element-35" />
          <a href="mailto:rawalraj2057@gmail.com" className="text-dark hover:text-secondary" data-id="element-36">
            rawalraj2057@gmail.com
          </a>
        </div>
      </div>
      {submitMessage ? <div className="bg-green-50 text-green-700 p-4 rounded-md mb-6" data-id="element-37">
          {submitMessage}
        </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-38">
          <div data-id="element-39">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40">
              Your Name
            </label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-41" />
          </div>
          <div data-id="element-42">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-43">
              Email Address
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-44" />
          </div>
          <div data-id="element-45">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-46">
              Phone Number
            </label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-47" />
          </div>
          <div data-id="element-48">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-49">
              Your Message
            </label>
            <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary" data-id="element-50"></textarea>
          </div>
          <button type="submit" disabled={isSubmitting} className="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3 px-4 rounded-md flex items-center justify-center transition-colors" data-id="element-51">
            {isSubmitting ? 'Sending...' : <>
                Send Message <Send size={18} className="ml-2" data-id="element-52" />
              </>}
          </button>
        </form>}
    </div>;
};